import { CommonConfirmationModal } from './common-confirmation.component';
import { CommonConfirmationModalRoutingModule } from './common-confirmation-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CommonConfirmationModalRoutingModule
  ],
  declarations: [CommonConfirmationModal]
})
export class CommonConfirmationModalModule { }
